import { defaultAllTasksFilterDocument } from '@griply/utils';
import {
  useAllTasksFilterDocument,
  useUpdateAllTasksFilterDocument,
} from 'features/user';
import React, { useRef } from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';
import { useAllTasksCustomOrderByGrouping } from 'shared/hooks/use-all-tasks-custom-order-by-grouping';
import { useAllTasksOnReorder } from 'shared/hooks/use-all-tasks-on-reorder';
import { useAllTasksOnSectionCollapse } from 'shared/hooks/use-all-tasks-on-section-collapse';
import {
  ContextMenuProvider,
  TaskFilterList,
} from 'shared/views/task-filter-list';

import * as Styled from './all-tasks.style';
import { ArchivedItemsList } from './components/archived-items-list';
import { MobileAddTaskButton } from './components/mobile-add-task-button';
import { PageTopBar } from './components/page-top-bar';

export const AllTasks: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const filterDocument = useAllTasksFilterDocument();
  const updateAllTasksFilterDocument = useUpdateAllTasksFilterDocument();

  const onReset = () =>
    updateAllTasksFilterDocument(defaultAllTasksFilterDocument);

  const customOrder = useAllTasksCustomOrderByGrouping(
    filterDocument.groupByMode,
  );
  const updateCustomOrder = useAllTasksOnReorder(filterDocument.groupByMode);
  const updateCollapsedSections = useAllTasksOnSectionCollapse();

  return (
    <Styled.Container>
      <Styled.Main>
        <VirtualizedTreeListProvider>
          <Styled.MainContent>
            <PageTopBar />

            <Styled.Content ref={scrollRef}>
              <ContextMenuProvider>
                <TaskFilterList
                  scrollElement={scrollRef}
                  filterDocument={filterDocument}
                  customOrder={customOrder}
                  onReorder={updateCustomOrder}
                  onSectionCollapse={updateCollapsedSections}
                  onReset={onReset}
                  groupSettings={undefined}
                />
                <ArchivedItemsList />
              </ContextMenuProvider>
            </Styled.Content>
          </Styled.MainContent>
        </VirtualizedTreeListProvider>
      </Styled.Main>

      <MobileAddTaskButton />
    </Styled.Container>
  );
};
